import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { HicreaSsoChangePasswordSentComponent } from './hicrea-sso-change-password-sent/hicrea-sso-change-password-sent.component';
import { HicreaSsoForgotPasswordComponent } from './hicrea-sso-forgot-password/hicrea-sso-forgot-password.component';
import { HicreaSsoInputComponent } from './hicrea-sso-input/hicrea-sso-input.component';
import { HicreaSsoLoginComponent } from './hicrea-sso-login/hicrea-sso-login.component';
import { HicreaSsoPasswordInputComponent } from './hicrea-sso-password-input/hicrea-sso-password-input.component';
import { HicreaSsoRegisterResendComponent } from './hicrea-sso-register-resend/hicrea-sso-register-resend.component';
import { HicreaSsoRegisterSendComponent } from './hicrea-sso-register-send/hicrea-sso-register-send.component';
import { HicreaSsoRegisterComponent } from './hicrea-sso-register/hicrea-sso-register.component';
import { HicreaSsoResetPasswordComponent } from './hicrea-sso-reset-password/hicrea-sso-reset-password.component';
import { HicreaSsoUnblockComponent } from './hicrea-sso-unblock/hicrea-sso-unblock.component';
import { HicreaSsoComponent } from './hicrea-sso/hicrea-sso.component';
import { OemService } from './oem.service';

@NgModule({
  declarations: [
    HicreaSsoComponent,
    HicreaSsoLoginComponent,
    HicreaSsoRegisterComponent,
    HicreaSsoUnblockComponent,
    HicreaSsoRegisterResendComponent,
    HicreaSsoRegisterSendComponent,
    HicreaSsoForgotPasswordComponent,
    HicreaSsoResetPasswordComponent,
    HicreaSsoChangePasswordSentComponent,
    HicreaSsoInputComponent,
    HicreaSsoPasswordInputComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    HicreaSsoResetPasswordComponent,
    HicreaSsoComponent,
    HicreaSsoRegisterResendComponent,
    HicreaSsoRegisterSendComponent,
    HicreaSsoUnblockComponent,
    HicreaSsoChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HicreaSsoModule {}
